import { axiosGet } from "../../../common/Helper/AxiosHelper";
import { Loader } from "@googlemaps/js-api-loader";
import AppFunction from "../../../core/helpers/app/AppFunction";

export default {
    data() {
        return {
            preloader: true,
            geoLoader: true,
            geoLocation: {
                location: "",
                work_from_home: false,
                error: "",
                coordinate: null
            },

            map: null,
            marker: null,
            circle: null,

            geoSettings: {},
            center: { lat: 0, lng: 0 },

            mixRadius: 0,
            mixLat: 0,
            mixLng: 0,

            apiKey: "AIzaSyDOASjG30CPkoMeBr_xuiBCdEkr0TVzTzI",
        };
    },

    methods: {
        // -------------------------------------------------
        // STEP 1 - Ask browser permission to access location
        // -------------------------------------------------
        getGeolocationSettings() {
            if (!navigator.geolocation) {
                alert("Geolocation is not supported by your browser.");
                return;
            }

            navigator.geolocation.getCurrentPosition(
                () => this.fetchGeolocationSettings(),
                (error) => {
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            alert("Location permission denied. Enable it to continue.");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            alert("Location information unavailable.");
                            break;
                        case error.TIMEOUT:
                            alert("Location request timed out.");
                            break;
                        default:
                            alert("Unknown location error.");
                    }
                }
            );
        },

        // -----------------------------------------------
        // STEP 2 - Get stored app geolocation settings
        // -----------------------------------------------
        fetchGeolocationSettings() {
            axiosGet(this.apiUrl.GEOLOCATION)
                .then(({ data }) => {
                    this.geoSettings = data;

                    if (data.service_name === "google_map") {
                        this.initializeGoogleMap(data.api_key);
                    } else {
                        document.querySelector("#googleMap").style.display = "none";
                        this.getGeoLocationData(data.ip_endpoint);
                    }
                })
                .catch(() => {
                    document.querySelector("#googleMap").style.display = "none";
                    this.geoLocation.error = "Cannot fetch IP data.";
                    this.geoLoader = false;
                });
        },

        // -----------------------------------------------
        // STEP 3 - Use navigator to get initial location
        // -----------------------------------------------
        getCurrentPositionByNavigator() {
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(
                    (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
                    (err) => reject(err)
                );
            });
        },

        // -----------------------------------------------
        // STEP 4 - Initialize Google Map
        // -----------------------------------------------
        async initializeGoogleMap(key) {
            try {
                const coords = this.mixLat && this.mixLng
                    ? { lat: this.formData.latitude, lng: this.formData.longitude }
                    : await this.getCurrentPositionByNavigator();

                this.center = coords;
                this.geoLocation.coordinate = coords;

                this.renderGoogleMap(key);
                this.getGoogleMapGeoLocationData(key, coords.lat, coords.lng);

            } catch (err) {
                this.geoLocation.error = "Invalid or expired Google API Key.";
                this.geoLoader = false;
            }
        },

        // -----------------------------------------------
        // STEP 5 - Render map with smooth draggable marker
        // -----------------------------------------------
        async renderGoogleMap(apiKey) {
            const loader = new Loader({
                apiKey,
                version: "weekly",
                libraries: ["places"],
            });

            const google = await loader.load();

            this.map = new google.maps.Map(document.getElementById("googleMap"), {
                center: this.center,
                zoom: 15,
                gestureHandling: "cooperative",
            });

            // --- Circle ---
            this.circle = new google.maps.Circle({
                map: this.map,
                center: this.center,
                radius: this.mixRadius,
                fillColor: "#C8E9F3",
                strokeColor: "#00ACD4",
                strokeWeight: 2,
            });

            // --- Smooth Draggable Marker ---
            this.marker = new google.maps.Marker({
                map: this.map,
                position: this.center,
                draggable: true,
                icon: AppFunction.getAppUrl("images/location_marker.svg"),
            });

            const infoWindow = new google.maps.InfoWindow();

            // On drag end update everything
            this.marker.addListener("dragend", (e) => {
                const pos = e.latLng;

                this.circle.setCenter(pos);
                this.formData.latitude = pos.lat();
                this.formData.longitude = pos.lng();
                this.mixLat = pos.lat();
                this.mixLng = pos.lng();

                infoWindow.setContent(
                    `Pin dropped at: ${pos.lat().toFixed(6)}, ${pos.lng().toFixed(6)}`
                );
                infoWindow.open(this.map, this.marker);
            });
        },

        // -----------------------------------------------
        // STEP 6 - Reverse geocode to get address
        // -----------------------------------------------
        getGoogleMapGeoLocationData(apiKey, lat, lng) {
            const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

            fetch(url)
                .then((res) => res.json())
                .then((data) => {
                    if (data.results.length) {
                        this.geoLocation.location = data.results[0].formatted_address;
                    }
                    this.getGeoLocationData(this.geoSettings.ip_endpoint);
                })
                .catch(() => {
                    this.geoLocation.error = "Failed to fetch location details.";
                    this.geoLoader = false;
                });
        },

        // -----------------------------------------------
        // STEP 7 - IP fallback lookup
        // -----------------------------------------------
        getGeoLocationData(url) {
            fetch(url)
                .then((r) => r.json())
                .then((data) => {
                    this.geoLocation = { ...this.geoLocation, ...data };
                })
                .catch(() => {
                    this.geoLocation.error = "Failed to fetch IP information.";
                })
                .finally(() => (this.geoLoader = false));
        },
    },
    watch:
        { 'formData.latitude': function (newVal, oldVal)
            { this.logValueChange(newVal, oldVal);
                if (this.circle) this.circle.lat = newVal;
                this.formData.latitude = newVal;
                this.mixLat = this.formData.latitude; // this.getGeolocationSettings();
            },
            'formData.longitude':
                function (newVal, oldVal)
                { this.logValueChange(newVal, oldVal);
                    if (this.circle) this.circle.lng = newVal;
                    this.formData.longitude = newVal;
                    this.mixLng = this.formData.longitude;
                    // this.getGeolocationSettings();
                    },
            'formData.radius': function (newVal, oldVal)
            { this.logValueChange(newVal, oldVal);
                this.mixRadius = newVal;
                if (this.circle)
                    this.circle.setRadius(parseFloat(newVal)); // this.getGeolocationSettings();
                },
            'center': function (newVal, oldVal)
            {
                this.formData.latitude = newVal.lat;
                this.formData.longitude = newVal.lng; }
        },

    created() {
        // this.mixRadius = this.formData.radius;
        // this.mixLat = this.formData.latitude;
        // this.mixLng = this.formData.longitude;

        this.getGeolocationSettings();
    },
};
